import { Text } from "@chakra-ui/react";
import Baremetal_Img from "public/bare-metal/baremetal-servers.png";
import { TEXT_VARIANTS } from "@/theme/components/text";

export const INTRO_CONSTANTS = {
  title: "Go Big. Go Bare Metal. Go OneMind.",
  description: [
    "At OneMind Cloud Services, we don’t just provide Bare Metal—we elevate it.",
    "We fuse the power of dedicated hardware with the agility of the cloud. Our Bare Metal solutions are cloud-native by design, offering full control, automated provisioning, and seamless scalability—without the operational complexity of traditional on-prem environments.",
    "Ideal for:",
  ],
  points: [
    "High-Performance Computing (HPC)",
    "Big Data & Analytics",
    "AI & ML Workloads",
    "Mission-Critical Applications",
  ],
  children: (
    <Text color="text.100" variant={TEXT_VARIANTS.BODY2}>
      Whether you’re scaling AI pipelines or pushing the limits of data processing,
      OneMind Bare Metal gives you the performance of dedicated hardware, with the
      flexibility and simplicity of the cloud.
    </Text>
  ),
  conclusion: "No compromise. No noise. Just power—yours to command.",
  image: Baremetal_Img,
};
